module.exports = __webpack_public_path__ + "e2ec6cb4b42ccd77a8f46c7b9d25c1c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/oracle_2021_chart.png
// module id = 1708
// module chunks = 0